import { UserContext } from "Contexts/UserContext/UserContext";
import React, { useContext, useState, useEffect } from "react";
import Script from "next/script";
import { TrackingContext } from "Contexts/TrackingContext/TrackingContext";
import useGlobalPrivacyControl from "Hooks/useGlobalPrivacyControl";
import AppName from "AppName";
//import useWindow from 'Hooks/useWindow'

export default function GoogleAnalytics4() {
  const { context: userContext } = useContext(UserContext);
  const trackingContext = useContext(TrackingContext)

  const [renderGA4, setShouldRenderGA4] = useState(false);
  const [gaTrackingId, setGaTrackingId] = useState();
  const { isGpcEnabled } = useGlobalPrivacyControl();

  useEffect(() => {
    const host = window.location.hostname.toLowerCase();

    switch (host) {
      case "www.speedwaymotors.com":
        setGaTrackingId("G-9NTXM7BJK3");
        break;
      case "staging.speedway2.com":
        setGaTrackingId("G-8L191PZ3ZF");
        break;
      case "qa.speedway2.com":
      default:
        setGaTrackingId("G-MK32X9Y3FD");
        break;
    }
  }, []);

  useEffect(() => {
    if (isGpcEnabled || !gaTrackingId || typeof gtag === 'undefined') {
      return
    }

    // update the tracking context so that we're ready to use session ids
    const sessionIdPromise = new Promise(resolve => {
      gtag('get', gaTrackingId, 'session_id', resolve)
    });
    const sessionNumPromise = new Promise(resolve => {
      gtag('get', gaTrackingId, 'session_number', resolve)
    });
    const clientIdPromise = new Promise(resolve => {
      gtag('get', gaTrackingId, 'client_id', resolve)
    });

    Promise.all([sessionIdPromise, sessionNumPromise, clientIdPromise]).then(function ([sessionId, sessionNumber, clientId]) {
      const ga4Session = {
        sessionId,
        sessionNumber,
        clientId
      }

      trackingContext.setGa4SessionData(ga4Session);
      window.ga4SessionData = ga4Session
      window.dispatchEvent(new CustomEvent('ga4Loaded', null))
    });

  }, [gaTrackingId, typeof gtag !== 'undefined', isGpcEnabled])

  useEffect(() => {
    // we need to wait until the user context has been updated with data (hydrated)
    // before allowing the script to render
    const shouldRender = !isGpcEnabled && userContext && userContext.hydrated && !userContext.isBot();
    if (shouldRender) {
      setShouldRenderGA4(true);
    }
  }, [userContext?.hydrated, isGpcEnabled]);

  // useWindow(() => {
  //   const ga3 = window.ga.bind(window.ga);
  //   window.ga = (...args) => {
  //     try {
  //       //ga4
  //       if(args && args[0] == 'send' && typeof(args[1]) == 'string' && args[1] == 'event') {
  //         gtag('event', 'ga3_event', {
  //           "send_to": "GA4",
  //           category: args[2],
  //           action: args[3],
  //           label: args[4],

  //         })
  //       }
  //       else if (args && args[0] == 'send' && typeof(args[1]) == 'object') {
  //         gtag('event', 'ga3_event', {
  //           "send_to": "GA4",
  //           category: args[1].eventCategory,
  //           action: args[1].eventAction,
  //           label: args[1].eventLabel
  //         })
  //       }
  //     } catch (e) {
  //       console.error(e);
  //     }

  //     try {
  //       ga3(...args);
  //     } catch (e) {
  //       console.error(e);
  //     }
  //   };
  // })
  console.log('GA4 boolean', isGpcEnabled || !renderGA4 || !gaTrackingId)

  if (isGpcEnabled || !renderGA4 || !gaTrackingId) {
    return false;
  }
  const webUserGuid = userContext.getGuid();

  // NOTE GTAG sends the pageview by default on the 'config' call
  // https://developers.google.com/analytics/devguides/collection/gtagjs/pages#default_behavior
  return (
    <>
      <Script
        id="ga4-script"
        data-testid="ga4-script"
        src={`https://www.googletagmanager.com/gtag/js?id=${gaTrackingId}`}
        strategy="afterInteractive"
      />
      <Script id="ga4-script-config" strategy="afterInteractive">
        {`
            // this is somewhat redundant as we have it in SsrScripts.js (first scripts to fire)
            // but it helps with storybook
            window.dataLayer = window.dataLayer || [];
                window.gtag = function() {
                dataLayer.push(arguments);
            }
            /////////////////////////////////////

            window.gtag("js", new Date());
            window.gtag("config", "${gaTrackingId}", {
              'user_id': '${webUserGuid}',
              'content_group': '${trackingContext?.ga4ContentGroup?.toString() ?? AppName}'
            });
        `}
      </Script>
    </>
  );
}
